import React, { Component } from 'react'
import { Tab } from 'semantic-ui-react'
import { connect } from 'react-redux'

import utils from '../../utils'

import CashOutList from './components/CashOutList'
import CashOutActions from '../../reducers/cashOutReducer'

const NUMBER_PER_PAGE = 20

class CashOut extends Component {
  componentDidMount() {
    const { syncPendingCashOuts } = this.props

    syncPendingCashOuts()
  }

  componentWillUnmount() {
    const { unSyncPendingCashOuts } = this.props

    unSyncPendingCashOuts()
  }

  renderPending = () => {
    const { cashOuts, confirmCashOut, cancelCashOut, loading } = this.props

    return (
      <Tab.Pane color="black" attached={false}>
        <CashOutList
          key="pending"
          tab="pending"
          loading={loading}
          cashOuts={cashOuts}
          cancelCashOut={cancelCashOut}
          confirmCashOut={confirmCashOut}
          numberPerPage={NUMBER_PER_PAGE}
          numberOfPages={Math.ceil(cashOuts.length / NUMBER_PER_PAGE)}
        />
      </Tab.Pane>
    )
  }

  renderHistory = () => {
    const { historyCashOuts, loading, getHistoryCashOuts } = this.props

    return (
      <Tab.Pane color="black" attached={false}>
        <CashOutList
          key="history"
          tab="history"
          loading={loading}
          cashOuts={historyCashOuts}
          numberPerPage={NUMBER_PER_PAGE}
          getHistoryCashOuts={getHistoryCashOuts}
          numberOfPages={Math.ceil(historyCashOuts.length / NUMBER_PER_PAGE)}
        />
      </Tab.Pane>
    )
  }

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/cashouts${queryString}`)
  }

  tabPanes = () => ({
      'pending': {
        menuItem: 'Pending', render: this.renderPending },
      'history': {
        menuItem: 'History', render: this.renderHistory
      }
    })

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'pending'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Tab
          activeIndex={tabIndex}
          menu={{ pointing: true }}
          panes={Object.values(this.tabPanes())}
          onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
        />
      </div>
    )
  }
}
const mapState = ({ cashOuts }) => ({
  cashOuts: cashOuts.data,
  loading: cashOuts.loading,
  historyCashOuts: cashOuts.history,
})

const mapDispatch = {
  cancelCashOut: CashOutActions.cancelCashOut,
  confirmCashOut: CashOutActions.confirmCashOut,
  getHistoryCashOuts: CashOutActions.getHistoryCashOuts,
  syncPendingCashOuts: CashOutActions.syncPendingCashOuts,
  unSyncPendingCashOuts: CashOutActions.unSyncPendingCashOuts,
}

export default connect(
  mapState,
  mapDispatch
)(CashOut)



// WEBPACK FOOTER //
// ./src/containers/cashOuts/index.js